import { apiRequest } from '@/utils/api-request';

export interface ListRunDaysParams {
  scheduleId?: string;
  dateFrom?: string;
  dateTo?: string;
  timezone?: string;
}

export interface RunDaysResponse {
  days?: string[];
  detail?: string;
}

export async function listRunDays(
  orgId: string,
  params: ListRunDaysParams = {},
): Promise<RunDaysResponse> {
  const query = new URLSearchParams();
  query.set('trigger_type', 'scheduled');
  if (params.scheduleId) query.set('schedule_id', params.scheduleId);
  if (params.dateFrom) query.set('date_from', params.dateFrom);
  if (params.dateTo) query.set('date_to', params.dateTo);
  if (params.timezone) query.set('timezone', params.timezone);

  const response = await apiRequest<RunDaysResponse>({
    url: `/api/v1/orgs/${orgId}/runs/calendar?${query.toString()}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  const data = response.data || response;
  return data as RunDaysResponse;
}
